import Immutable from 'immutable';
import EventsConstants from '../../constants/EventsConstants';

const initialState = Immutable.fromJS({
  results: [],
  pagination: {},
  facetFields: {},
  query: {},
  isFetching: false
});

export default function eventsSearch(state = initialState, action) {
  switch (action.type) {
    case EventsConstants.SEARCH_EVENTS_REQUEST: {
      return state.merge({
        isFetching: true
      });
    }

    case EventsConstants.SEARCH_EVENTS_SUCCESS: {
      return state.merge({
        ...action.payload.events,
        query: action.query,
        isFetching: false
      });
    }

    case EventsConstants.SEARCH_EVENTS_FAILURE: {
      return initialState;
    }

    default:
      return state;
  }
}
